import { Box } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { AnchorProps } from "./Anchor.d";

const Anchor = ({ id, sbEditable }: SbEditableComponentProps<AnchorProps>) => (
  <Box id={id} pos="relative" top={-24} {...sbEditable} />
);

export default Anchor;
